const { PAPER_TYPES } = require("./bookPapers");
const BROCHURE_MIN_SPINE_MM = 3;
const BROCHURE_MAX_SPINE_MM = 36;
const BROCHURE_SPINE_RULE =
  "A lombada de Brochura deve medir entre 3 mm e 36 mm (3,6 cm), incluindo os limites.";
const number = (value) => Number(String(value ?? "").replace(",", "."));
function paperThickness(paper = {}) {
  paper = paper || {};
  const known = PAPER_TYPES.find(
    (item) =>
      item.id === (paper.id || paper.paperId) || item.label === (paper.label || paper.paperLabel)
  );
  return known?.thicknessMicron || number(paper.thicknessMicron) || 0;
}
function getSpineMm(book = {}) {
  const pages = number(book.pdf?.pages);
  const thickness = paperThickness(book.paper);
  // Do not let a manually entered shipping depth override the calculated spine.
  if (pages > 0 && thickness > 0) return (pages * thickness) / 2000;
  const measured = number(book.depthCm);
  return measured > 0 && Number.isFinite(measured) ? measured * 10 : 0;
}
function getBrochureSpineError(book) {
  if (
    String(book.finish || "")
      .trim()
      .toLowerCase() !== "brochura"
  )
    return "";
  const spine = getSpineMm(book);
  return spine >= BROCHURE_MIN_SPINE_MM && spine <= BROCHURE_MAX_SPINE_MM
    ? ""
    : BROCHURE_SPINE_RULE;
}
module.exports = {
  BROCHURE_MIN_SPINE_MM,
  BROCHURE_MAX_SPINE_MM,
  BROCHURE_SPINE_RULE,
  paperThickness,
  getSpineMm,
  getBrochureSpineError,
};
